module.exports = __webpack_public_path__ + "static/img/light-red.e024dd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/light-red.png
// module id = clzG
// module chunks = 1